/**
 * @generated SignedSource<<3f27c53efbc43971691345fb693d41e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FlightReleaseStatusEnum = "FULLY_RELEASED" | "NOT_RELEASED" | "PARTIALLY_RELEASED" | "%future added value";
export type client_type = "BEACON" | "DOCK" | "EXTERNAL_RADIO" | "JOYSTICKS" | "MISSION_CONDUCTOR" | "MOBILE" | "SCHEDULER" | "SKYSTICKS" | "UNKNOWN" | "VEHICLE" | "WEB" | "%future added value";
export type docktype = "DOCK" | "G47" | "GROUND" | "PEDESTAL" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FlightListItem_flight$data = {
  readonly cjiStatus: FlightReleaseStatusEnum | null;
  readonly dock: {
    readonly displayName: string;
    readonly dockId: string;
    readonly dockType: docktype;
    readonly id: string;
  } | null;
  readonly fileReleaseStatus: FlightReleaseStatusEnum | null;
  readonly hasTelemetry: boolean | null;
  readonly id: string;
  readonly landingLocation: {
    readonly latitude: number | null;
    readonly longitude: number | null;
  } | null;
  readonly takeoffClientType: client_type;
  readonly takeoffLocation: {
    readonly latitude: number | null;
    readonly longitude: number | null;
  } | null;
  readonly user: {
    readonly displayName: string | null;
    readonly email: string;
    readonly id: string;
  } | null;
  readonly uuid: string;
  readonly vehicle: {
    readonly displayName: string;
    readonly id: string;
    readonly isOnLte: boolean | null;
    readonly isOnline: boolean | null;
    readonly vehicleId: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"FlightAnnotations_flight" | "useFlightDuration_fragment">;
  readonly " $fragmentType": "FlightListItem_flight";
};
export type FlightListItem_flight$key = {
  readonly " $data"?: FlightListItem_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightListItem_flight">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "latitude",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "longitude",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightListItem_flight",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightAnnotations_flight"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFlightDuration_fragment"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasTelemetry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "takeoffClientType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileReleaseStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cjiStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "takeoffLocation",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "landingLocation",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Vehicle",
      "kind": "LinkedField",
      "name": "vehicle",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOnline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOnLte",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vehicleId",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dock",
      "kind": "LinkedField",
      "name": "dock",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dockId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dockType",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};
})();

(node as any).hash = "717eae2975399cb982e397c4a6da6a95";

export default node;
